import {createTheme} from '@mui/material/styles'

const materialTheme = createTheme({
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 0,
        },
        paperFullWidth: {
          width: '100%',
        },
        paperWidthMd: {
          maxWidth: '850px', // added px for fixed value
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          margin: '0',
          padding: '0 3.3rem 3.3rem',
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: '3.3rem',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: '3.3rem',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: '#FF5000',
          fontSize: '1.2rem',
          fontWeight: 'bolder',
          lineHeight: '1.8rem',
          textTransform: 'uppercase',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottom: '2px solid #191919',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            border: 0,
          },
          width: '100%',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: '#191919',
          },
          color: '#969696',
        },
        shrink: {
          color: '#191919',
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        divider: {
          borderBottomColor: 'rgba(0,0,0,0.5)',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          maxHeight: '29rem',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        colorPrimary: {
          color: '#FF5000',
        },
        root: {
          color: '#191919',
          height: '3rem',
          width: '3rem',
        },
      },
    },
  },
  palette: {
    primary: {
      dark: '#FF5000',
      main: '#191919',
    },
  },
  typography: {
    // useNextVariants is no longer needed in MUI v5+
  },
})
export default materialTheme
